import { memo, RefObject } from 'react'
import { IVersionHistoryItem } from 'store/types/aiVideo'
import AISkeletonItem from 'components/AISkeletonItem'

import * as Styled from './styled'

interface IVersionHistoryItemProps {
  item: IVersionHistoryItem
  isLoading: boolean
  handleLoad: VoidFunction
  videoRef: RefObject<HTMLVideoElement | null>
}

const VersionHistoryItemContent = ({
  item,
  isLoading,
  videoRef,
  handleLoad
}: IVersionHistoryItemProps) => {
  return (
    <>
      {isLoading &&
        (item.type === 'video' && item.thumbnailUrl ? (
          <Styled.ThumbnailImage src={item.thumbnailUrl} />
        ) : (
          <AISkeletonItem width="100%" height="100%" />
        ))}
      {item.type === 'video' ? (
        <Styled.VideoElement
          ref={videoRef}
          src={item.url}
          onLoadedData={handleLoad}
          $isLoading={isLoading}
          crossOrigin="anonymous"
          muted
          loop
          playsInline
        />
      ) : (
        <Styled.ImageElement
          src={item.url}
          onLoad={handleLoad}
          $isLoading={isLoading}
        />
      )}
    </>
  )
}

export default memo(VersionHistoryItemContent)
